export const emptyValue = '—'

export const earningsHeadlineLevels = {
  operating: 'operating',
  product: 'product',
}
